import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.keyValue && sessionStorage.getItem(this.keyValue)) {
      this.element.remove()
    }
  }

  dismiss() {
    if (this.keyValue) {
      sessionStorage.setItem(this.keyValue, "true")
    }
    this.element.remove()
  }
}
